var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c("modal", {
        staticClass: "regulation",
        attrs: {
          show: _vm.showModal,
          showContent: _vm.showContent,
          pageTitle: _vm.title,
          acl: _vm.acl,
          url: _vm.url,
          position: "left",
        },
        on: { close: _vm.closeModal },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "panel-control d-flex flex-column flex-fill",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "panel-control-content d-flex flex-column flex-fill",
                        },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col" }, [
                              _c("span", { staticClass: "title" }, [
                                _vm._v(" " + _vm._s(_vm.title)),
                              ]),
                              _vm._v(" "),
                              _c("hr"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col" }, [
                              _c(
                                "div",
                                { staticClass: "d-flex flex-column flex-fill" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "panel" },
                                    [
                                      _c("tree-grouped-links", {
                                        attrs: {
                                          nodes: _vm.items,
                                          emptyMessage: _vm.emptyMessage,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          2090806265
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }